import React from 'react'
import './MenuLanguageFlag.scss'

const MenuLanguageFlag = (props) => {
    return <img className="main-menu__language-flag" src={props.src} alt={'flag'} />
}

export default MenuLanguageFlag
